import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import  Meta from 'vue-meta';
Vue.use(Meta);
Vue.config.productionTip = false
Vue.prototype.$defaultImg=function(event){ //地址错误时，设置默认图片
  console.log(2);
  let img = event.srcElement;
  img.src ='https://static.nbd.com.cn/images/default-.gif';
  img.onerror = null; //防止闪图
},


router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo)
      store.commit("CAHNGE_META_INFO", to.meta.metaInfo)
  next()
});

new Vue({
  router,
  store,
  metaInfo(){
    return {
        title: this.$store.state.metaInfo.title,
        meta: [
            {
                name: "keywords",
                content: this.$store.state.metaInfo.keywords
            }, {
                name: "description",
                content: this.$store.state.metaInfo.description
            }
        ]
    }
},
  render: h => h(App)
}).$mount('#app')
